import API from '../../components/api'
import { WorkareaPricing } from './workareaPricing'

export type WorkareaPricingSelection = {
  workareaIds?: number[]
  visitIds?: string[]
  actualItemIds?: string[]
  includeNonVisitItems?: boolean
  uninvoicedOnly?: boolean
}

export type WorkareaSelectedPricing = {
  workareaId: number
  actual: WorkareaPricing
  completedVisits: WorkareaPricing | null
}

export type WorkareaPricingPreviewRequest = {
  workSubtotal: number
  customerTotal?: number | null
}

export type WorkareaPricingPreview = {
  calculatedEstimate: WorkareaPricing
  estimated: WorkareaPricing
  error: null
}

export const getSelectedWorkareaPricing = async (jobId: number, selection: WorkareaPricingSelection): Promise<WorkareaSelectedPricing[]> => {
  const response = await API.post<WorkareaSelectedPricing[]>(`/web/jobs/${jobId}/workarea-pricing/selection`, selection)
  return response.data
}

export const previewWorkareaPricing = async (workareaId: number, request: WorkareaPricingPreviewRequest): Promise<WorkareaPricingPreview> => {
  const response = await API.post<WorkareaPricingPreview>(`/web/workareas/${workareaId}/pricing/preview`, request)
  return response.data
}
